import { render, staticRenderFns } from "./LeftSidebar.vue?vue&type=template&id=780647a3&scoped=true&"
import script from "./LeftSidebar.vue?vue&type=script&lang=js&"
export * from "./LeftSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LeftSidebar.vue?vue&type=style&index=0&id=780647a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780647a3",
  null
  
)

export default component.exports